module.exports = __webpack_public_path__ + "images/9a57b2f87cb9e3bfd6946ee4216bb7f3-modelS.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modelS.jpg
// module id = ./src/assets/images/modelS.jpg
// module chunks = 0